<template>
  <div id="service_predictor">
    <div class="container-fluid">
      <div class="row">
        <div
          class="col-md-3 border-end p-0 overflow-y-auto"
          ref="sidebarContainer"
        >
          <div class="col-md-12">
            <div class="p-3 border-bottom">
              <div class="title">Service Availability Predictor</div>
              <div class="form-group">
                <label class="sub-title pb-2">Email</label>
                <input
                  type="email"
                  name="email"
                  class="form-control"
                  v-model="email"
                  :class="emailError ? 'border-danger' : ''"
                  @change="findOperators"
                  @keyup="isAuthenticationInputValid"
                />
                <div class="text-danger mt-2 mb-2" v-if="emailErrorMsg">
                  {{ emailErrorMsg }}
                </div>
              </div>
              <div class="form-group">
                <label class="sub-title pb-2">Operator API Key</label>
                <input
                  type="password"
                  name="operatorKey"
                  class="form-control"
                  v-model="operatorKey"
                  :class="operatorKeyError ? 'border-danger' : ''"
                  @change="findOperators(true)"
                  @keyup="isAuthenticationInputValid"
                />
              </div>
              <div class="col-md-12 mt-2 mb-2">
                <div class="text-danger mb-2" v-if="keyResponse">
                  {{ keyResponse }}
                </div>
                <button
                  type="button"
                  class="btn btn-predictor"
                  :disabled="disableAuthButton"
                  @click="checkAPIKeyHealth"
                >
                  Authenticate
                </button>
                <!-- <button
                  type="button"
                  class="btn btn-predictor ms-2"
                  @click="clearInputs"
                  v-if="keyResponse"
                >
                  <i class="fa fa-times"></i> Clear
                </button> -->
              </div>

              <div class="form-group">
                <label class="sub-title pb-2">Operator</label>
                <input
                  type="text"
                  name="operator"
                  class="form-control"
                  :value="operator"
                  :disabled="operatorDisabled"
                  :class="operatorError ? 'border-danger' : ''"
                  @change="updateOperator($event.target.value)"
                />
              </div>
              <div
                class="col-md-12 mt-2 mb-1 text-indigo"
                v-if="operatorLoading"
              >
                <i class="fa fa-spinner fa-spin me-1"></i> Fetching available
                operators. Please wait.
              </div>
              <div
                class="col-md-12 mt-2 mb-1 text-danger"
                v-if="
                  operatorError && operatorNames.length > 0 && !operatorLoading
                "
              >
                Operator entered is invalid.
                <a
                  href="#"
                  @click="showOperatorModal = true"
                  class="text-indigo"
                  >Click here</a
                >
                to select an operator.
              </div>
              <div
                class="col-md-12 mt-2 mb-1 text-danger"
                v-if="
                  operatorError &&
                  operatorNames.length == 0 &&
                  remoteAddress &&
                  !operatorLoading &&
                  !operatorDisabled
                "
              >
                There is no operator at this address. Please try again using
                another address.
              </div>
            </div>
          </div>
          <div class="col-md-12 px-3 mt-3">
            <div class="mt-2">
              <base-node
                ref="baseNodeRef"
                :operator-key="operatorKey"
                :operator="operator"
                @update-sector="activeSector = $event"
              />
              <bn-by-radius
                ref="baseNodeByRadiusRef"
                :operator-key="operatorKey"
                :operator="operator"
                @get-operators="findOperators"
                @base-node-list="getBaseNodeList"
              />
            </div>
            <div class="mt-2">
              <remote-node
                ref="remoteNodeRef"
                @get-operators="findOperators"
                @clear-rn-marker="handleClearRNMarker"
              />
            </div>
          </div>
          <div class="col-md-12 p-3 mb-3">
            <button
              type="button"
              class="btn btn-predictor me-2 mb-1"
              @click="calculateLost"
            >
              Calculate Path Loss & Speed
            </button>
            <button
              type="button"
              class="btn btn-predictor me-2 mb-1"
              v-if="successful && !showInfoDiv"
              @click="toggleModal"
            >
              Show Path Profile
            </button>
            <button
              type="button"
              class="btn btn-predictor me-2 mb-1"
              v-if="baseNodeList.bn_list?.length"
              @click="toggleBNRadius"
            >
              {{ showBNRadiusDiv ? "Hide Sectors" : "Show Sectors" }}
            </button>
            <button
              type="button"
              class="btn btn-predictor mb-1"
              v-if="removeRemoteButton && sectorResults"
              @click="handleClearRNMarker"
            >
              Remove New Pin
            </button>
          </div>
        </div>
        <div class="col-md-9 p-0">
          <div class="container-fluid">
            <div class="row no-gutters">
              <div class="col-md-12 p-0 position-relative">
                <google-map
                  :operator-key="operatorKey"
                  :load-map-radius="loadMapRadius"
                  :hover-marker-data="hoverMarkerData"
                  :base-node-list="baseNodeList"
                  :remote-address="remoteAddress"
                  :remote-lat-lng="remoteLatLng"
                  :sector-results="sectorResults"
                  :active-sector="activeSector"
                  :heatmap-data="heatmapData"
                  :multi-sector="multiSector"
                  :clear-remote-node="clearRNMarker"
                  :loading-button="loadingButton"
                  @reset-all="clearInputs"
                  @map-path-hover="handleMapPathHover"
                  @update-lat-lng="handleUpdateLatLng"
                  @update-bn-radius="handleUpdateBaseNodeRadius"
                  @update-base-node="handleUpdateBaseNode"
                  @manage-base-node="manageBaseNodeData"
                  @update-results-modal="handleUpdateResultsModal"
                  @update-active-height="handleUpdateActiveHeight"
                />
                <!-- Overlay Modal -->
                <div class="overlay" v-if="successful && showInfoDiv">
                  <div class="overlay-content">
                    <div class="card">
                      <div class="card-body set-max-height">
                        <div class="close" @click="toggleModal">&times;</div>
                        <div class="row">
                          <div class="col-md-12" v-if="apiResponse">
                            <div class="text-danger text-center">
                              API Response: {{ apiResponse }}
                            </div>
                          </div>
                          <div
                            class="modal-flex-container col-md-12"
                            v-if="profileSvg && !apiResponse"
                          >
                            <div class="info-column">
                              <!--<div class="info-text" v-if="linkCloseConfidence">
                                Link Close Confidence:
                                {{ (linkCloseConfidence * 100).toFixed(0) }}%
                              </div>
                              <div class="info-text" v-if="pathLossData">
                                Predicted Path Loss:
                                {{ pathLossData.average }}
                              </div> -->
                              <template v-for="remoteInfo in remoteNodeDetails">
                                <div
                                  class="info-box"
                                  :class="{
                                    'acive-info':
                                      String(getActiveHeight(remoteInfo)) ===
                                        String(activeRemoteHeight) &&
                                      activeRemoteInfo === remoteInfo,
                                  }"
                                  @click="appendResultsOnModal(remoteInfo)"
                                >
                                  Height:
                                  <span class="fw-bold">{{
                                    showHeightText(remoteInfo)
                                  }}</span
                                  ><br />Link Close Confidence:
                                  <span class="fw-bold"
                                    >{{
                                      (
                                        remoteInfo?.aiml_output
                                          ?.link_close_confidence * 100
                                      ).toFixed(0)
                                    }}%</span
                                  ><br />
                                  Predicted Path Loss:
                                  <span
                                    class="fw-bold"
                                    v-html="getPathLoss(remoteInfo)"
                                  ></span
                                  ><br />
                                  <span>
                                    Link Speed:
                                    <span class="fw-bold">{{
                                      calculateSpeed(remoteInfo)
                                    }}</span></span
                                  >
                                  <div
                                    v-if="
                                      String(getActiveHeight(remoteInfo)) ===
                                        String(activeRemoteHeight) &&
                                      activeRemoteInfo === remoteInfo
                                    "
                                  >
                                    RN Mount:
                                    <div class="ps-3">
                                      Height:
                                      <span
                                        v-html="showRNMountHeight(remoteInfo)"
                                      ></span
                                      ><br />
                                      Azimuth:
                                      <span
                                        class="fw-bold"
                                        v-html="getAzimuth(remoteInfo)"
                                      ></span
                                      ><br />
                                      Tilt:
                                      <span
                                        class="fw-bold"
                                        v-html="getTilt(remoteInfo)"
                                      ></span>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </div>
                            <div class="graph-column img-enlarge">
                              <div class="svg-loader" v-if="loadingSvg">
                                <i class="fa fa-circle-notch fa-spin fa-4x"></i>
                              </div>
                              <div
                                class="svg-wrapper"
                                v-if="profileSvgData && !loadingSvg"
                              >
                              <div
                                  v-html="profileSvgData"
                                  class="svg-container"
                                  id="profile-svg-container"
                                  @click="enlargeImage('line')"
                                ></div>
                                <button
                                  class="enlarge-button"
                                  @click="enlargeImage('line')"
                                >
                                  <i class="fa fa-expand"></i> Enlarge Image
                                </button>
                              </div>
                            </div>
                          </div>
                          <!-- <div class="col-md-12 graph-bg">
                            <div class="row">
                              <div
                                class="col-md-6 img-enlarge"
                                v-if="pathLossData"
                              >
                                <img
                                  v-if="pathLossSvg"
                                  :src="pathLossSvg"
                                  class="svg-container"
                                  id="path-loss-svg-container"
                                />
                                <button
                                  class="enlarge-button"
                                  @click="enlargeImage('path-loss')"
                                >
                                  <i class="fa fa-expand"></i> Enlarge Image
                                </button>
                              </div>
                              <div
                                class="col-md-6 img-enlarge"
                                v-if="linkSpeedData"
                              >
                                <img
                                  v-if="linkSpeedSvg"
                                  :src="linkSpeedSvg"
                                  class="svg-container"
                                  id="link-speed-svg-container"
                                />
                                <button
                                  class="enlarge-button"
                                  @click="enlargeImage('link-speed')"
                                >
                                  <i class="fa fa-expand"></i> Enlarge Image
                                </button>
                              </div>
                            </div>
                          </div> -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="dialog"
        id="svg-popup"
        v-if="dialogVisible"
        @click.self="closeDialog"
      >
        <div
          class="dialog-content"
          :class="svgType === 'line' ? 'diagram-width' : 'graph-width'"
          @click.stop
        >
          <button @click="closeDialog" class="close-icon">
            <i class="fa fa-times" aria-hidden="true"></i>
          </button>
          <div class="row">
            <div class="col-md-12">
              <img
                :src="svgContent"
                class="dialog-svg-container"
                id="svg-container"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Modal -->
  <div
    class="modal fade show"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modalLabel"
    :class="showOperatorModal ? 'd-block' : ''"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="modalLabel">Operator List</h5>
          <button
            type="button"
            class="btn-close"
            @click="showOperatorModal = false"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div v-if="operatorNames.length > 0">
            <p>Select an operator from the list below:</p>
            <ul class="list-group">
              <li
                v-for="(operator, index) in operatorNames"
                :key="index"
                class="list-group-item fw-bold"
              >
                {{ operator }}
                <div class="float-end">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="selectOperator(operator)"
                  >
                    Select Operator
                  </button>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <p>No operators found at this address.</p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            @click="showOperatorModal = false"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseNode from "./BaseNode.vue";
import RemoteNode from "./RemoteNode.vue";
import BNByRadius from "./BNByRadius.vue";
import GoogleMap from "./GoogleMap.vue";
export default {
  components: {
    "base-node": BaseNode,
    "remote-node": RemoteNode,
    "bn-by-radius": BNByRadius,
    "google-map": GoogleMap,
  },
  data() {
    return {
      successful: false,
      operatorKey: "",
      email: "",
      operator: "",
      keyResponse: "",
      remoteAddress: "",
      prevRemoteAddress: "",
      remoteLatLng: {},
      showOperatorModal: false,
      disableAuthButton: true,
      emailError: false,
      emailErrorMsg: "",
      operatorError: false,
      operatorLoading: false,
      operatorKeyCheck: false,
      operatorKeyError: false,
      operatorDisabled: true,
      clearRNMarker: false,
      loadingSvg: false,
      activeTab: "base-remote-node",
      svgContent: "",
      profileSvg: "",
      profileSvgData: "",
      pathLossData: "",
      linkSpeedData: "",
      pathLossSvg: "",
      linkSpeedSvg: "",
      linkCloseConfidence: 0,
      multiSector: false,
      showInfoDiv: false,
      showBNRadiusDiv: false,
      dialogVisible: false,
      loadMapRadius: false,
      loadingButton: false,
      removeRemoteButton: false,
      abortController: new AbortController(),
      svgType: "",
      svgIndicator: "",
      svgStartX: 0,
      svgEndX: 0,
      apiResponse: "",
      hoverMarkerData: null,
      activeSector: null,
      activeRemoteHeight: null,
      activeRemoteInfo: null,
      devOnly: runtimeConfig.VUE_APP_DEV_ONLY_FEATURE,
      activeBaseInfo: null,
      heatmapData: [],
      operatorNames: [],
      baseNodeList: [],
      sectorResults: [],
      remoteNodeDetails: [],
    };
  },
  mounted() {
    const rowElement = this.$refs.sidebarContainer;
    if (rowElement && window.innerWidth > 767) {
      rowElement.style.height = window.innerHeight - 40 + "px";
    }
    this.toogleActiveTab(this.activeTab);
    window.addEventListener("resize", this.toggleModal);
    if (localStorage.getItem("operator_key")) {
      this.operatorKey = localStorage.getItem("operator_key");
    }
    if (localStorage.getItem("email")) {
      this.email = localStorage.getItem("email");
    }
    if (this.operatorKey && this.email) {
      this.disableAuthButton = false;
      this.checkAPIKeyHealth();
    }
  },
  watch: {
    profileSvgData() {
      this.makeSVGResponsive("profile-svg-container");
    },
  },
  methods: {
    toogleActiveTab(tab) {
      this.activeTab = tab;
      let remoteRef = this.$refs.remoteNodeRef;
      remoteRef.findByAddress = true;
      remoteRef.remoteAddress = true;
    },
    clearInputs(data) {
      this.emailErrorMsg = "";
      this.keyResponse = "";
      this.remoteAddress = "";
      this.prevRemoteAddress = "";
      this.svgContent = "";
      this.profileSvg = "";
      this.pathLossData = "";
      this.linkSpeedData = "";
      this.profileSvgData = "";
      this.pathLossSvg = "";
      this.linkSpeedSvg = "";
      this.svgType = "";
      this.apiResponse = "";
      this.linkCloseConfidence = 0;
      this.activeRemoteHeight = null;
      this.activeSector = null;
      this.operatorNames = [];
      this.sectorResults = [];
      this.remoteNodeDetails = [];

      this.successful = false;
      this.showOperatorModal = false;
      this.showInfoDiv = false;
      this.showBNRadiusDiv = true;
      this.dialogVisible = false;
      this.clearRNMarker = false;
      this.removeRemoteButton = false;
      this.$refs.remoteNodeRef.clearInputs();
      this.$refs.baseNodeRef.clearInputs(data);
      this.$refs.baseNodeByRadiusRef.clearInputs();
    },
    enlargeImage(diagram) {
      this.dialogVisible = true;
      if (diagram == "line") {
        this.svgContent = this.profileSvg;
        this.svgType = "line";
      }
      if (diagram == "path-loss") {
        this.svgContent = this.pathLossSvg;
        this.svgType = "graph";
      }
      if (diagram == "link-speed") {
        this.svgContent = this.linkSpeedSvg;
        this.svgType = "graph";
      }
      // Call makeSVGResponsive after SVG content is updated
      this.$nextTick(() => {
        this.makeDialogSVGResponsive();
      });
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    toggleModal() {
      this.showInfoDiv = !this.showInfoDiv;
      if (this.showInfoDiv) {
        // Call makeSVGResponsive after SVG content is updated
        this.$nextTick(() => {
          this.makeSVGResponsive("profile-svg-container");
          //this.makeSVGResponsive("path-loss-svg-container");
          //this.makeSVGResponsive("link-speed-svg-container");
        });
      }
    },
    makeSVGResponsive(svg_id) {
      const svgContainer = document.getElementById(svg_id);
          if (!svgContainer) return;

          const svg = svgContainer.querySelector("svg");
          if (!svg) return;

          // Make SVG responsive
          svg.removeAttribute("width");
          svg.removeAttribute("height");
          const bbox = svg.getBBox();
      svg.setAttribute(
        "viewBox",
        `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`
      );
      svg.style.width = "100%";
      svg.style.height = "auto";
      let diagram = "";
      if (svg_id == "path-loss-svg-container") {
        diagram = "path-loss";
      } else if (svg_id == "link-speed-svg-container") {
        diagram = "link-speed";
      } else {
        diagram = "line";
      }
      svg.addEventListener("click", () => {
        this.enlargeImage(diagram);
      });
      // Remove existing indicator line if present
      const existingLine = svg.querySelector("#svg-indicator");
      if (existingLine) existingLine.remove();
      // Create indicator line
      const svgNamespace = "http://www.w3.org/2000/svg";
      const indicatorLine = document.createElementNS(svgNamespace, "line");
      indicatorLine.setAttribute("id", "svg-indicator");
      indicatorLine.setAttribute("y1", bbox.y); // align with viewBox
      indicatorLine.setAttribute("y2", bbox.y + bbox.height);
      indicatorLine.setAttribute("stroke", "red");
      indicatorLine.setAttribute("stroke-width", "2");
      indicatorLine.setAttribute("visibility", "hidden");
      this.svgIndicator = indicatorLine;
      const targetGroup = svg.querySelector('g[style*="clipPath_0"]');
      if (targetGroup) {
        targetGroup.appendChild(this.svgIndicator);
      }
      // Assign ID to LOS path
      const losPath = svg.querySelector("polyline[stroke-dasharray]");
      if (losPath) {
        losPath.id = "los-path";
        this.calculateSvgBounds(losPath);
      }

      // Add hover rectangle for event handling
      const hoverRectangle = this.createHoverRectangle(svg);
      hoverRectangle.addEventListener("mousemove", (event) =>
        this.handleSvgMouseMove(event)
      );
      hoverRectangle.addEventListener("mouseout", () =>
        this.handleSvgMouseOut()
      );

      // Adjust sidebar height if needed
      const rowElement = this.$refs.sidebarContainer;
      if (rowElement && window.innerWidth > 767) {
        rowElement.style.height = window.innerHeight - 40 + "px";
      }
    },
    calculateSvgBounds(pathElement) {
      const startPoint = pathElement.getPointAtLength(0);
      const endPoint = pathElement.getPointAtLength(
        pathElement.getTotalLength()
      );
      this.svgStartX = startPoint.x;
      this.svgEndX = endPoint.x;
    },
    createHoverRectangle(svg) {
      const originalClippedGroup = svg.querySelector('g[style*="clipPath_0"]');
      if (!originalClippedGroup) return null;
      const svgNamespace = "http://www.w3.org/2000/svg";
      // 1. Create a new group to serve as our interactive layer.
      const interactiveGroup = document.createElementNS(svgNamespace, "g");
      // 2. Apply the exact same clip-path style.
      interactiveGroup.setAttribute("style", "clip-path: url(#clipPath_0);");
      // 3. Create the hover rectangle.
      const hoverRect = document.createElementNS(svgNamespace, "rect");
      const rectX = this.svgStartX;
      const rectY = 40.5;
      const rectWidth = this.svgEndX - this.svgStartX;
      const rectHeight = 380;
      hoverRect.setAttribute("id", "hover-area");
      hoverRect.setAttribute("x", rectX.toString());
      hoverRect.setAttribute("y", rectY.toString());
      hoverRect.setAttribute("width", rectWidth.toString());
      hoverRect.setAttribute("height", rectHeight.toString());
      hoverRect.setAttribute("fill", "transparent");
      hoverRect.setAttribute("pointer-events", "all");
      // 4. Append the rectangle to our new group, and the new group to the SVG.
      interactiveGroup.appendChild(hoverRect);
      svg.appendChild(interactiveGroup); // Append to root SVG to ensure it's on top of the original group
      return hoverRect;
    },
    makeDialogSVGResponsive() {
      const svgId = "svg-container";
      const svgContainer = document
        .getElementById("svg-popup")
        .querySelector(`#${svgId}`);
      if (svgContainer) {
        const svg = svgContainer.querySelector("svg");
        if (svg) {
          svg.removeAttribute("width");
          svg.removeAttribute("height");

          // Set viewBox attribute based on the SVG content's bounding box
          const bbox = svg.getBBox();
          svg.setAttribute(
            "viewBox",
            `${bbox.x} ${bbox.y} ${bbox.width} ${bbox.height}`
          );
        }
      }
    },
    handleSvgMouseMove(event) {
      const svg = event.target.ownerSVGElement;
      const losPath = document.querySelector("#los-path");
      // Guard clauses to prevent errors
      if (
        !svg ||
        !losPath ||
        !this.svgIndicator ||
        !this.activeBaseInfo ||
        !this.activeRemoteInfo
      ) {
        return;
      }
      // Get the cursor's X position in SVG's internal coordinate system.
      const pt = svg.createSVGPoint();
      pt.x = event.clientX;
      const cursorPoint = pt.matrixTransform(svg.getScreenCTM().inverse());
      const cursorX = cursorPoint.x;
      // Immediately move the vertical indicator to the cursor's horizontal position.
      if (this.svgIndicator) {
        this.svgIndicator.setAttribute("x1", cursorX.toString());
        this.svgIndicator.setAttribute("x2", cursorX.toString());
        this.svgIndicator.setAttribute("visibility", "visible");
      }
      // Define the two lines needed for the intersection calculation.
      // The full line-of-sight path.
      const p1 = losPath.getPointAtLength(0);
      const p2 = losPath.getPointAtLength(losPath.getTotalLength());
      // The vertical line at the cursor's current X position.
      const p3 = { x: cursorX, y: 40.5 };
      const p4 = { x: cursorX, y: 420.5 };
      // Find the exact intersection point of these two lines.
      const intersection = this.getIntersection(p1, p2, p3, p4);
      if (intersection) {
        const totalWidth = this.svgEndX - this.svgStartX;
        const intersectWidth = intersection.x - this.svgStartX;
        const percentage = totalWidth > 0 ? intersectWidth / totalWidth : 0;
        const clampedPercentage = Math.max(0, Math.min(1, percentage));
        const transmitterLatLng = new google.maps.LatLng(
          parseFloat(this.activeBaseInfo.latitude),
          parseFloat(this.activeBaseInfo.longitude)
        );
        const receiverLatLng = new google.maps.LatLng(
          parseFloat(this.activeRemoteInfo.rn.latitude),
          parseFloat(this.activeRemoteInfo.rn.longitude)
        );
        // Use the Google Maps geometry library to interpolate along the geodesic path.
        const newLatLng = google.maps.geometry.spherical.interpolate(
          transmitterLatLng,
          receiverLatLng,
          clampedPercentage
        );
        // Set the hover data using the precise coordinates from the API.
        this.hoverMarkerData = {
          lat: newLatLng.lat(),
          lng: newLatLng.lng(),
        };
      } else {
        this.handleSvgMouseOut();
      }
    },
    handleSvgMouseOut() {
      this.hoverMarkerData = null;
      if (this.svgIndicator) {
        this.svgIndicator.setAttribute("visibility", "hidden");
      }
    },
    getIntersection(p1, p2, p3, p4) {
      const den = (p1.x - p2.x) * (p3.y - p4.y) - (p1.y - p2.y) * (p3.x - p4.x);
      if (den === 0) return null; // Parallel lines
      const t =
        ((p1.x - p3.x) * (p3.y - p4.y) - (p1.y - p3.y) * (p3.x - p4.x)) / den;
      const u =
        -((p1.x - p2.x) * (p1.y - p3.y) - (p1.y - p2.y) * (p1.x - p3.x)) / den;
      // Check if the intersection point is on both line segments
      if (t >= 0 && t <= 1 && u >= 0 && u <= 1) {
        return { x: p1.x + t * (p2.x - p1.x), y: p1.y + t * (p2.y - p1.y) };
      }
      return null;
    },
    selectOperator(val) {
      this.operator = val;
      this.operatorError = false;
      this.showOperatorModal = false;
      this.loadingButton = true;
      this.loadMapRadius = true;
    },
    checkAPIKeyHealth() {
      this.emailError = false;
      this.operatorKeyError = false;
      this.loadMapRadius = false;
      this.operatorDisabled = true;
      this.disableAuthButton = false;
      this.operatorError = false;
      this.operator = "";
      this.keyResponse = "";
      if (this.operatorKey != "" && this.isEmailValid()) {
        let loader = this.$loading.show({
          canCancel: false,
          color: "#0367a9",
        });

        const urlPart = "/v0/health/api-key";

        // Define the request data
        const requestData = {
          url_part: urlPart,
          api_key: this.operatorKey,
        };

        try {
          this.$axios
            .post("sap-request", requestData)
            .then((response) => {
              loader.hide();
              this.operatorKeyCheck = true;
              this.loadMapRadius = true;
              if (response.data.detail) {
                this.keyResponse = response.data.detail;
                this.operatorKeyError = true;
                if (localStorage.getItem("operator_key")) {
                  localStorage.removeItem("operator_key");
                }
                if (localStorage.getItem("email")) {
                  localStorage.removeItem("email");
                }
              } else {
                if (!response.data.operator) {
                  this.keyResponse = "Invalid API Key";
                } else {
                  if (response.data.operator != "Tarana") {
                    this.operator = response.data.operator;
                  } else {
                    this.operatorDisabled = false;
                  }
                  localStorage.setItem("operator_key", this.operatorKey);
                  localStorage.setItem("email", this.email);
                  alert("Successfully Authenticated");
                }
              }
            })
            .catch(() => {
              loader.hide();
              console.log("Error");
            });
        } catch (error) {
          loader.hide();
          console.error("Error:", error);
        }
      } else {
        this.operatorKeyError = this.operatorKey != "" ? false : true;
        this.emailError = this.isEmailValid() ? false : true;
        this.disableAuthButton =
          !this.operatorKeyError && !this.emailError ? false : true;
      }
    },
    handleMapPathHover(data) {
      if (data) {
        const svgSpanX = this.svgEndX - this.svgStartX;
        const newSvgX = this.svgStartX + svgSpanX * data.percentage;
        this.svgIndicator.setAttribute("x1", newSvgX);
        this.svgIndicator.setAttribute("x2", newSvgX);
        this.svgIndicator.setAttribute("visibility", "visible");
      } else {
        this.svgIndicator.removeAttribute("x1");
        this.svgIndicator.removeAttribute("x2");
        this.svgIndicator.setAttribute("visibility", "hidden");
      }
    },
    handleUpdateLatLng(data) {
      this.$refs.remoteNodeRef.updateFields(data);
      this.clearRNMarker = false;
      this.removeRemoteButton = data.remote_pin;
      if (!data.clicked && data.address) {
        this.findOperators();
      }
    },
    handleUpdateBaseNodeRadius(data) {
      this.loadingButton = true;
      this.loadMapRadius = false;
      let baseRef = this.$refs.baseNodeByRadiusRef;
      baseRef.updateFields(data);
      this.checkOperatorExist();
      let remoteRef = this.$refs.remoteNodeRef;
      remoteRef.addressUpdated = true;
      this.remoteAddress = remoteRef.rn_address;
    },
    handleUpdateBaseNode(data) {
      let baseRef = this.$refs.baseNodeRef;
      this.activeBaseInfo = data.base_node;
      if (data.from_result) {
        baseRef.inputDisable("all");
        this.heatmapData = {
          ...this.heatmapData,
          base_node: this.activeBaseInfo,
        };
      }
      baseRef.updateFields(this.activeBaseInfo);
      if (data.hasOwnProperty("sector_options")) {
        baseRef.updateSectorOptions(data.sector_options);
      }
      if (baseRef.baseNodeOption != "all") {
        if (!data.from_result) {
          baseRef.inputDisable("use_specific");
        }
      }
    },
    manageBaseNodeData(data) {
      let baseRef = this.$refs.baseNodeRef;
      if (!data.heatmap_exist) {
        baseRef.clearInputs(data);
      } else {
        baseRef.updateFields(this.activeBaseInfo);
      }
    },
    isAuthenticationInputValid() {
      this.disableAuthButton =
        this.operatorKey != "" && this.isEmailValid() ? false : true;
    },
    isEmailValid() {
      this.emailErrorMsg = "";
      if (this.email != "") {
        const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        const checkEmail = emailPattern.test(this.email);
        if (!checkEmail) {
          this.emailErrorMsg = "Invalid Email";
        }
        return checkEmail;
      }
      return false;
    },
    handleClearRNMarker() {
      this.clearRNMarker = true;
      let remoteRef = this.$refs.remoteNodeRef;
      remoteRef.rn_address = this.prevRemoteAddress;
    },
    findOperators(keyChange = false) {
      if (keyChange) this.baseNodeList = [];
      let remoteRef = this.$refs.remoteNodeRef;
      remoteRef.addressError = false;
      if (remoteRef.addressUpdated) {
        this.remoteAddress = remoteRef.rn_address;
      }
      this.remoteLatLng = {};
      if (remoteRef.latlngUpdated) {
        this.remoteLatLng = remoteRef.rn_location ?? {};
      }
      this.loadingButton = false;
      if (this.remoteAddress && this.operatorKey && !this.operatorDisabled) {
        this.operatorLoading = true;
        this.operatorNames = [];
        const urlPart = "/v0/find/operators";

        // Define the request data
        const requestData = {
          url_part: `${
            urlPart + "/" + encodeURIComponent(this.remoteAddress)
          }?_t=${Date.now()}`, // Unique request to prevent caching
          api_key: this.operatorKey,
        };

        // Abort previous request if still running
        if (this.abortController) {
          this.abortController.abort();
        }

        // Create a new AbortController
        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.$axios
          .post("sap-request", requestData, { signal })
          .then((response) => {
            this.operatorLoading = false;
            if (response.data.detail) {
              this.addressErrorMsg = response.data.detail;
            } else if (response.data.operator_list) {
              this.operatorNames = response.data.operator_list.map(
                (operator) => operator.name
              );
              this.checkOperatorExist();
            }
          })
          .catch((error) => {
            if (this.$axios.isCancel(error)) {
              console.log("Request was canceled:", error.message);
              return;
            }
            console.error("Error:", error);
          });
      } else {
        remoteRef.addressError = !this.remoteAddress ? true : false;
      }
    },
    getBaseNodeList(data = "") {
      this.loadingButton = false;
      this.loadMapRadius = false;
      this.showBNRadiusDiv = true;
      if (data) {
        this.baseNodeList = data;
        this.baseNodeList.showBNRadius =
          this.baseNodeList.bn_list.length > 0 ? true : false;
      }
    },
    toggleBNRadius() {
      this.showBNRadiusDiv = !this.showBNRadiusDiv;
      this.baseNodeList.showBNRadius = this.showBNRadiusDiv;
    },
    isFormValid() {
      // Perform validation on BaseNode and RemoteNode
      const baseNodeValid = this.$refs.baseNodeRef.isFormValid();
      const remoteNodeValid = this.$refs.remoteNodeRef.isFormValid();
      return (
        baseNodeValid &&
        remoteNodeValid &&
        this.operatorKey.trim() &&
        this.email.trim() &&
        this.operator.trim() &&
        !this.operatorError &&
        !this.operatorLoading
      );
    },
    updateOperator(value) {
      this.operator = value ?? "";
      this.checkOperatorExist(true);
    },
    checkOperatorExist(update = false) {
      this.operatorError = false;
      if (this.operatorNames.length > 0 && !this.operatorDisabled) {
        if (!this.operatorNames.includes(this.operator)) {
          this.operatorError = true;
        }
      }
      if (this.operator && !this.operatorError && update) {
        this.loadingButton = true;
      }
    },
    calculateLost() {
      let remoteRef = this.$refs.remoteNodeRef;
      let baseRef = this.$refs.baseNodeRef;

      if (this.isFormValid()) {
        this.loadingButton = false;
        this.successful = false;
        this.showInfoDiv = false;
        this.multiSector = false;
        this.apiResponse = "";
        this.profileSvgData = "";
        let jsonArray = [];
        this.sectorResults = [];

        let bnObject = baseRef.getJsonData();
        if (!baseRef.disabled && baseRef.baseNodeOption != "all") {
          jsonArray["bn"] = bnObject;
        }

        let rnObject = remoteRef.getJsonData();
        jsonArray["rn_list"] = [rnObject];

        let loader = this.$loading.show({
          canCancel: false,
          color: "#0367a9",
        });

        let optionsParams = "csv_files=false";

        let urlPart =
          "/v0/predict/sector?options=" + encodeURIComponent(optionsParams);

        if (baseRef.baseNodeOption == "all") {
          urlPart =
            "/v0/predict/multi-sector?options=" +
            encodeURIComponent(optionsParams);
        }

        // Define the request data
        const jsonObject = { ...jsonArray };
        if (this.operator != "") {
          jsonObject.operator = this.operator;
        }
        if (this.email != "") {
          jsonObject.email = this.email;
        }
        const requestData = {
          url_part: urlPart,
          json_data: jsonObject,
          api_key: this.operatorKey,
        };

        try {
          this.$axios
            .post("sap-request", requestData)
            .then((response) => {
              this.successful = true;
              this.showInfoDiv = true;
              this.removeRemoteButton = false;
              this.prevRemoteAddress = remoteRef.rn_address;
              loader.hide();

              if (response.data.detail) {
                this.apiResponse = response.data.detail;
              } else {
                if (response.data.sector_list) {
                  this.multiSector = true;
                }
                this.sectorResults = response.data;
              }
            })
            .catch(() => {
              loader.hide();
              console.log("Error");
            });
        } catch (error) {
          loader.hide();
          console.error("Error:", error);
        }
      } else {
        this.operatorKeyError = this.operatorKey != "" ? false : true;
        this.checkOperatorExist();
      }
    },
    showPoleHeightText(remoteData) {
      let heightType = remoteData?.mount?.location ?? "";
      let poleHeightText = "";
      if (heightType) {
        let rnPoleHeight = remoteData?.mount_heights?.pole;
        poleHeightText += rnPoleHeight + " m ";
        heightType = heightType.replace(/\b\w/g, (char) => char.toUpperCase());
        poleHeightText += "(" + heightType + ")";
      }
      return poleHeightText;
    },
    showHeightText(remoteData) {
      let heightType = remoteData?.mount?.location ?? "";
      let heightText = "";
      if (heightType) {
        let rnHeight =
          heightType.toLowerCase() == "above building"
            ? remoteData?.rn?.heights?.above_roof
            : remoteData?.rn?.heights?.above_open;
        heightText += rnHeight + " m ";
        heightType = heightType.replace(/\b\w/g, (char) => char.toUpperCase());
        heightText += " (" + heightType + ")";
      }

      return heightText;
    },
    showRNMountHeight(remoteData) {
      let mountHeights = remoteData?.mount_heights;
      let mountHeightText = "";
      if (mountHeights && Object.keys(mountHeights).length > 0) {
        let poleHeight = mountHeights.pole || 0;
        const [key, value] = Object.entries(mountHeights)[0];
        const label = key.charAt(0).toUpperCase() + key.slice(1);
        mountHeightText += `${label} <b>${value.toFixed(2)} m</b>, <br>`;
        mountHeightText += `Pole <b>${poleHeight} m</b>, `;
        mountHeightText += `Total AGL <b>${(poleHeight + value).toFixed(
          2
        )} m</b>`;
      }
      return mountHeightText;
    },
    getActiveHeight(remoteData) {
      let heightType = remoteData?.mount?.location ?? "";
      if (heightType) {
        let rnMountHeight =
          heightType.toLowerCase() == "above building"
            ? remoteData?.rn?.heights?.above_roof
            : remoteData?.rn?.heights?.above_open;
        let activeHeight = null;
        rnMountHeight = Number(rnMountHeight);
        if (!isNaN(rnMountHeight)) {
          if ([3, 10].includes(rnMountHeight)) {
            activeHeight = "3_10";
          } else if ([2, 7].includes(rnMountHeight)) {
            activeHeight = "2_7";
          } else if ([1, 5].includes(rnMountHeight)) {
            activeHeight = "1_5";
          }
        }
        return activeHeight;
      }
      return null;
    },
    getTilt(remoteInfo) {
      if (remoteInfo?.rn_tilt !== undefined) {
        return parseFloat(remoteInfo?.rn_tilt).toFixed(1) + "&deg;";
      }
      return "";
    },
    getAzimuth(remoteInfo) {
      if (remoteInfo?.bn_rn_angle !== undefined) {
        return ((parseFloat(remoteInfo.bn_rn_angle) + 180) % 360) + "&deg;";
      }
      return "";
    },
    getPathLoss(remoteInfo) {
      if (remoteInfo?.aiml_output?.path_loss?.average !== undefined) {
        return (
          Math.round(parseFloat(remoteInfo?.aiml_output?.path_loss?.average)) +
          " dB"
        );
      }
      return "";
    },
    sortRemoteData(remoteNodes) {
      return remoteNodes
        .slice() // Create a copy to avoid mutating the original array
        .sort((a, b) => {
          const heightA = a?.mount?.height_agl ?? 0;
          const heightB = b?.mount?.height_agl ?? 0;
          return heightB - heightA; // Descending order (highest height first)
        });
    },
    handleUpdateActiveHeight(data) {
      if (!data.remove_result) {
        if (data.height) {
          this.activeRemoteHeight = data.height;
        } else if (data.remote_data) {
          this.activeRemoteHeight = this.getActiveHeight(data.remote_data);
        }
        if (data.remote_list && this.activeRemoteHeight) {
          const matchedRemote = data.remote_list.find((node) => {
            return (
              String(this.getActiveHeight(node)) ===
              String(this.activeRemoteHeight)
            );
          });
          this.activeRemoteInfo = matchedRemote || data.remote_data;
        }
        if (data.base_node) {
          if (data.base_node.serial == this.activeBaseInfo.serial) {
            this.showInfoDiv = true;
            this.successful = true;
          }
        }
      }
    },
    handleUpdateResultsModal(data) {
      if (!data) {
        this.apiResponse =
          "No results are displayed because all remote nodes have a link close confidence below 0.25 or no base nodes exist near the remote node address.";
      } else {
        if (data.remote_list) {
          this.remoteNodeDetails = this.sortRemoteData(data.remote_list);
        }
        if (data.heatmap) {
          this.heatmapData = {
            ...this.heatmapData,
            heatmap_list: data.heatmap ?? [],
          };
        }
        if (data.remote_data) {
          this.apiResponse = "";
          this.profileSvgData = "";
          this.activeRemoteHeight = null;
          this.activeRemoteInfo = null;
          this.appendResultsOnModal(data.remote_data);
        }
        if (data.line_click) {
          this.showInfoDiv = true;
          this.successful = true;
        }
        if (data.remove_result) {
          this.showInfoDiv = false;
          this.successful = false;
        }
      }
    },
    appendResultsOnModal(remoteData) {
      this.activeRemoteInfo = remoteData;
      // Get active height and update heatmapData
      const height = this.getActiveHeight(remoteData);
      this.activeRemoteHeight = height;
      this.heatmapData = {
        ...this.heatmapData,
        activeHeight: height,
      };

      if (remoteData.aiml_output.path_loss) {
        this.pathLossData = remoteData.aiml_output.path_loss;
        this.pathLossSvg = this.pathLossData.cdf_url;
        // Call makeSVGResponsive after SVG content is updated
        this.$nextTick(() => {
          this.makeSVGResponsive("path-loss-svg-container");
        });
      }
      if (remoteData.aiml_output.link_speed) {
        this.linkSpeedData = remoteData.aiml_output.link_speed;
        this.linkSpeedSvg = this.linkSpeedData.cdf_url;
        // Call makeSVGResponsive after SVG content is updated
        this.$nextTick(() => {
          this.makeSVGResponsive("link-speed-svg-container");
        });
      }
      if (remoteData.aiml_output.link_close_confidence) {
        this.linkCloseConfidence = remoteData.aiml_output.link_close_confidence;
      }
      if (remoteData.profile_url) {
        this.profileSvg = remoteData.profile_url;
        this.getProfileSVGData();
      }
    },
    getProfileSVGData() {
      try {
        this.loadingSvg = true;
        this.$axios
          .get(`/get-svg?url=${encodeURIComponent(this.profileSvg)}`, {
            responseType: "text",
          })
          .then((response) => {
            this.loadingSvg = false;
            this.profileSvgData = response.data;
            // Call makeSVGResponsive after SVG content is updated
            this.$nextTick(() => {
              this.makeSVGResponsive("profile-svg-container");
            });
          })
          .catch(() => {
            this.loadingSvg = false;
            console.log("Error");
          });
      } catch (error) {
        this.loadingSvg = false;
        console.error("Error:", error);
      }
    },
    calculateSpeed(remoteInfo) {
      let pathLoss = remoteInfo?.aiml_output?.path_loss?.average;
      //let linkSpeed = remoteInfo?.aiml_output?.link_speed?.average;
      let calculatedSpeed = 0;
      if (this.activeBaseInfo) {
        let bnCarriers = this.activeBaseInfo.carrier[0].frequency;
        calculatedSpeed = this.mapl(pathLoss, bnCarriers);
      }
      let speed = parseFloat(calculatedSpeed);
      return Math.round(speed) + " Mbps";
    },
    mapl(pathLoss, carrier) {
      if (carrier < 5000) {
        return Math.min(
          Math.max((640.0 * (160.0 - pathLoss)) / (160.0 - 133.0), 0.0),
          640.0
        );
      } else {
        return Math.min(
          Math.max((640.0 * (148.0 - pathLoss)) / (148.0 - 123.0), 0.0),
          640.0
        );
      }
    },
  },
  beforeUnmount() {
    // ✅ Abort any ongoing request when component unmounts
    if (this.abortController) {
      this.abortController.abort();
    }
  },
};
</script>
